import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Card } from '@agion/ui'
import { Terminal } from 'lucide-react'
import { PageHeader } from '@/layouts/InfraPageHeader'
import { HostLogsViewer } from './InfraHostLogsViewer'

export function HostLogsPage() {
  const { t } = useTranslation(['pages'])
  const { id } = useParams<{ id: string }>()

  if (!id) return null

  return (
    <div className="p-6 space-y-6">
      <PageHeader
        icon={Terminal}
        title={t('pages:hostLogs.title', 'Host Logs')}
        description={t('pages:hostLogs.description', 'Live systemd journal stream for debugging. Copy logs for LLM sessions.')}
      />
      <Card>
        <div className="p-4">
          <HostLogsViewer hostId={id} />
        </div>
      </Card>
    </div>
  )
}
